// ATENDIMENTO
// SCROLL ON CLICK LINK
$('aside a').on('click', function() {
	event.preventDefault();
	$('html, body').animate({
		scrollTop: $('.atendimento_finalContent').offset().top - 90
	}, 800);
});

// AJAX CONTEUDO
if ($('.atendimento_finalContent').length) {	
	function ajaxAtendimento(finalUrl) {
		$.ajax({
			url: finalUrl,
			success: function(data) {
				$('.atendimento_finalContent').html(data);

                $('.foneMask').focusout(function () {
                    var phone, element;
                    element = $(this);
                    element.unmask();
                    phone = element.val().replace(/\D/g, '');
                    if (phone.length > 10) {
                        element.mask("(99) 99999-999?9");
                    } else {
                        element.mask("(99) 9999-9999?9");
                    }
                }).trigger('focusout');

                $('#statusEnvio').hide();

                $("#formOrcamento").validate({
                    submitHandler: function (form) {
                        //SUBMIT form

                        var isValid;
                        $(".ipt_qtdProduto").each(function() {
                            var element = $(this);
                            if (element.val() == "") {
                                isValid = false;
                            }
                        });

                        if (isValid) {
                            $(form).ajaxSubmit({
                                beforeSubmit: function () {
                                    $('#statusEnvio').show();
                                    $('#statusEnvio').html('<span> Enviando, aguarde...</span>');
                                    $('#btnEnviarOrcamento').attr('disabled', true);
                                },
                                success: function (result) {
                                    result = result.split('|');
                                    console.log(result[0] + ' - ' + result[1]);
                                    if (result[0].length == 1) {
                                        if (parseInt(result[0]) == 1) {
                                            $('#statusEnvio').html(result[1]);
                                            $(form)[0].reset();

                                            setTimeout(function () {
                                                $('#btnEnviarOrcamento').attr('disabled', false);
                                                $('#statusEnvio').hide();
                                                $('#statusEnvio').empty();
                                            }, 2000);
                                        }
                                    } else {
                                        $('#btnEnviarOrcamento').attr('disabled', false);
                                        $('#statusEnvio').html(result);
                                        setTimeout(function () {
                                            $('#statusEnvio').hide();
                                            $('#statusEnvio').empty();
                                            $('#btnEnviarOrcamento').attr('disabled', false);
                                        }, 3000);
                                    }
                                }
                            });
                        } else {
                            $('#statusEnvio').show();
                            $('#statusEnvio').html('Todas as quantidades devem estar preenchidas!');
                            setTimeout(function () {
                                $('#btnEnviarOrcamento').attr('disabled', false);
                                $('#statusEnvio').hide();
                                $('#statusEnvio').empty();
                            }, 2000);
                        }
                    }
                });

                $("#formContato").validate({
                    submitHandler: function (form) {
                        //SUBMIT form
                        $(form).ajaxSubmit({
                            beforeSubmit: function () {
                                $('#statusEnvio').show();
                                $('#statusEnvio').html('<span> Enviando, aguarde...</span>');
                                $('#btnEnviarContato').attr('disabled', true);
                            },
                            success: function (result) {
                                result = result.split('|');
                                console.log(result[0]+' - '+result[1]);
                                if (result[0].length == 1){
                                    if(parseInt(result[0]) == 1){
                                        $('#statusEnvio').html(result[1]);
                                        $(form)[0].reset();

                                        setTimeout(function(){
                                            $('#btnEnviarContato').attr('disabled',false);
                                            $('#statusEnvio').hide();
                                            $('#statusEnvio').empty();
                                        },2000);
                                    }
                                }else{
                                    $('#btnEnviarContato').attr('disabled',false);
                                    $('#statusEnvio').html(result);
                                    setTimeout(function () {
                                        $('#statusEnvio').hide();
                                        $('#statusEnvio').empty();
                                        $('#btnEnviarContato').attr('disabled', false);
                                    }, 3000);
                                }
                            }
                        });
                    }
                });

                $("#formLigamos").validate({
                    submitHandler: function (form) {
                        //SUBMIT form
                        $(form).ajaxSubmit({
                            beforeSubmit: function () {
                                $('#statusEnvio').show();
                                $('#statusEnvio').html('<span> Enviando, aguarde...</span>');
                                $('#btnEnviarLigamos').attr('disabled', true);
                            },
                            success: function (result) {
                                result = result.split('|');
                                console.log(result[0]+' - '+result[1]);
                                if (result[0].length == 1){
                                    if(parseInt(result[0]) == 1){
                                        $('#statusEnvio').html(result[1]);
                                        $(form)[0].reset();

                                        setTimeout(function(){
                                            $('#btnEnviarLigamos').attr('disabled',false);
                                            $('#statusEnvio').hide();
                                            $('#statusEnvio').empty();
                                        },2000);
                                    }
                                }else{
                                    $('#btnEnviarLigamos').attr('disabled',false);
                                    $('#statusEnvio').html(result);
                                    setTimeout(function () {
                                        $('#statusEnvio').hide();
                                        $('#statusEnvio').empty();
                                        $('#btnEnviarLigamos').attr('disabled', false);
                                    }, 3000);
                                }
                            }
                        });
                    }
                });

                $("#formCurriculo").validate({
                    submitHandler: function (form) {
                        //SUBMIT form
                        $(form).ajaxSubmit({
                            beforeSubmit: function () {
                                $('#statusEnvio').show();
                                $('#statusEnvio').html('<span class="loading"> Enviando, aguarde...</span>');
                                $('#btnEnviarCurriculo').attr('disabled', true);
                            },
                            success: function (result) {
                                result = result.split('|');
                                console.log(result[0]+' - '+result[1]);
                                if (result[0].length == 1){
                                    if(parseInt(result[0]) == 1){
                                        $('#statusEnvio').html(result[1]);
                                        $(form)[0].reset();
                                        setTimeout(function(){
                                            $('#btnEnviarCurriculo').attr('disabled',false);
                                            $('#statusEnvio').hide();
                                            $('#statusEnvio').empty();
                                        },2000);
                                    }
                                }else{
                                    $('#btnEnviarCurriculo').attr('disabled',false);
                                    $('#statusEnvio').html(result);
                                    setTimeout(function () {
                                        $('#statusEnvio').hide();
                                        $('#statusEnvio').empty();
                                        $('#btnEnviarCurriculo').attr('disabled', false);
                                    }, 3000);
                                }
                            }
                        });
                    }
                });
			},
			beforeSend: function() {
				$('.loader').show();
			},
			complete: function() {
				$('.loader').hide();
			}
		});
	}

	function asideActived() {
		$('.atendimento_aside li').removeClass('is-active');
		var asideActive = window.location.hash.replace('#','');
		console.log(asideActive);
		$('.atendimento_aside a[data-conteudo='+asideActive+']').parent('li').addClass('is-active');
	}

	$('.atendimento_aside a').on('click', function(event) {
		event.preventDefault();
		$('.atendimento_aside li').removeClass('is-active');
		$(this).parent('li').addClass('is-active');

		var carregaUrl = $(this).attr('data-conteudo');
		var finalUrl = ('components/'+carregaUrl+'.php');
		window.location.hash = carregaUrl;

		ajaxAtendimento(finalUrl);
	});	

	switch(window.location.hash) {
		case '#s_atendimento_orcamento':
		   	var finalUrl = ('components/s_atendimento_orcamento.php');
		   	ajaxAtendimento(finalUrl);
		   	asideActived();
		    break;
		case '#s_atendimento_trabalhe':
		    var finalUrl = ('components/s_atendimento_trabalhe.php');
		    ajaxAtendimento(finalUrl);
		   	asideActived();
		break;
		case '#s_atendimento_email':
		    var finalUrl = ('components/s_atendimento_email.php');
		    ajaxAtendimento(finalUrl);
		   	asideActived();
		break;
		case '#s_atendimento_localizacao':
		    var finalUrl = ('components/s_atendimento_localizacao.php');
		    ajaxAtendimento(finalUrl);
		   	asideActived();
		break;
		case '#s_atendimento_telefone':
		    var finalUrl = ('components/s_atendimento_telefone.php');
		    ajaxAtendimento(finalUrl);
		   	asideActived();
		break;

		default:
		    var finalUrl = ('components/s_atendimento_orcamento.php');
		    window.location.hash = '#s_atendimento_orcamento';
		   	ajaxAtendimento(finalUrl);
		   	asideActived();
	}
}

// Nav ajuste
if ($('nav').length) {
	$('.defaultNav__menu a').each(function(index, el) {
		var attrThis = $(this).attr('href');
		attrThis = attrThis.replace('#', './#');
		$(this).attr('href', attrThis);
	});
}

// COMPONENTE
// DROP DOWN MENU - PRODUTOS - ORCAMENTO
// OPEN SUB MENU
$(document).on('click', '.c-dropDown_products > input', function() {
	$(this).parent().children('ul').toggleClass('is-active');
});

// Select checkbox on li click
$(document).on('click', '.c-dropDown_products li', function() {
	$(this).toggleClass('li_checked');
		if ($(this).hasClass('li_checked')) {
		$(this).children('.checkBox').children('input').prop('checked', true);
	} else {
		$(this).children('.checkBox').children('input').prop('checked', false);
	}
});

// click btn to add products in list
$(document).on('click', '.btn__addOrder', function() {
	$('.c-dropDown_products ul').removeClass('is-active');
		$('.li_checked').each(function(index) {
            var content = $(this).html();
            var nomProduto = $(this).find('h3').html();
			var hidPrd = '<input type="hidden" name="namProduto[]" value="' + nomProduto + '" />';
			var iptQtd = '<input class="ipt_qtdProduto" type="text" name="qtdProduto[]" id="qtdProduto" placeholder="Digite a quantidade" />';
			$('.c-listOrder_products ul').append('<li>' + content + hidPrd + iptQtd + '</li>');
			$('.formList > li.u-dnone').removeClass('u-dnone');
		});
	$('.c-dropDown_products li.li_checked').hide().removeClass('li_checked');
});